// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { MenuItem, Select, Typography } from '@mui/material';
import { useGetAllInstrumentConfigurations } from '../hooks/queries/useGetAllInstrumentConfigurations';
import { configsByContractId } from '../utils/configsByContractId';

interface InstrumentSelectProps {
  onSelect: (instrumentId: string, instrumentRegistrar: string, index?: number) => void;
  instrumentId: string;
  index?: number;
  selectedInstruments?: string[];
}

export const InstrumentSelect: React.FC<InstrumentSelectProps> = ({
  instrumentId,
  onSelect,
  index,
  selectedInstruments,
}) => {
  const { data } = useGetAllInstrumentConfigurations();
  const configs = configsByContractId(data);
  return (
    <Select
      variant="outlined"
      displayEmpty
      size="small"
      fullWidth
      renderValue={(value: string) => {
        if (!value) {
          return <Typography color="gray">Select Instrument</Typography>;
        }
        return value;
      }}
      value={instrumentId}
      onChange={(e) => {
        const instrument = configs[e.target.value];
        const { payload } = instrument;

        onSelect(payload.defaultIdentifier.id, payload.defaultIdentifier.source, index);
      }}
    >
      {data?.instrumentConfigurations.map((i) => {
        const { payload, contract } = i;
        return (
          <MenuItem
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
            disabled={selectedInstruments?.includes(i.payload.defaultIdentifier.id)}
            key={contract.contractId}
            id={payload.defaultIdentifier.source}
            value={contract.contractId}
          >
            <Typography>{payload.defaultIdentifier.id}</Typography>
            <Typography sx={{ textOverflow: 'ellipsis' }}>
              {payload.defaultIdentifier.source}
            </Typography>
          </MenuItem>
        );
      })}
    </Select>
  );
};
